const rolesList = state => state.roles;

const selectedRole = state => state.selectedRole;

const permissions = state => state.permissions;

const allPermissions = state => state.allPermissions;
export default {
    rolesList,
    selectedRole,
    permissions,
    allPermissions
}